import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import { useNavigate } from 'react-router-dom';
import {
  FaThLarge,
  FaCalendarAlt,
  FaUserInjured,
  FaFileInvoice,
  FaProcedures,
  FaTasks,
  FaDesktop,
  FaCompass,
  FaPrescription,
  FaBoxes,
  FaTruckLoading,
  FaWarehouse,
  FaAddressBook,
  FaCashRegister,
  FaBed,
  FaHospital,
  FaPills,
  FaFlask,
  FaBoxOpen,
  FaUsers,
  FaFileInvoiceDollar,
  FaUserMd,
  FaPaperclip,
  FaCommentAlt,
  FaCreditCard,
  FaShieldAlt,
  FaStethoscope,
  FaChevronDown,
  FaChevronUp,
  FaTimes
} from 'react-icons/fa';

const getMenuIcon = (name) => {
  switch (name?.toUpperCase()) {
    case 'DASHBOARD': return <FaThLarge className="menu-icon" />;
    case 'APPOINTMENTS': return <FaCalendarAlt className="menu-icon" />;
    case 'PATIENTS': return <FaUserInjured className="menu-icon" />;
    case 'REPORT':
    case 'REPORTS': return <FaFileInvoice className="menu-icon" />;
    case 'ADMISSIONS': return <FaProcedures className="menu-icon" />;
    case 'MANAGE': return <FaTasks className="menu-icon" />;
    case 'MONITOR': return <FaDesktop className="menu-icon" />;
    case 'IP TOUR':
    case 'PHARMACY TOUR': return <FaCompass className="menu-icon" />;
    case 'PRESCRIPTIONS': return <FaPrescription className="menu-icon" />;
    case 'ITEMS': return <FaBoxes className="menu-icon" />;
    case 'PURCHASE ENTRIES': return <FaTruckLoading className="menu-icon" />;
    case 'STOCK': return <FaWarehouse className="menu-icon" />;
    case 'SUPPLIERS': return <FaAddressBook className="menu-icon" />;
    case 'CASH COUNTER': return <FaCashRegister className="menu-icon" />;
    case 'ADMITTED PATIENTS': return <FaBed className="menu-icon" />;
    case 'HOSPITAL': return <FaHospital className="menu-icon" />;
    case 'PHARMACY': return <FaPills className="menu-icon" />;
    case 'LAB': return <FaFlask className="menu-icon" />;
    case 'OP/IP PACKAGES': return <FaBoxOpen className="menu-icon" />;
    case 'USERS': return <FaUsers className="menu-icon" />;
    case 'HOSPITAL CHARGES': return <FaFileInvoiceDollar className="menu-icon" />;
    case 'DOCTOR PAYMENTS': return <FaUserMd className="menu-icon" />;
    case 'ALL ATTACHMENTS': return <FaPaperclip className="menu-icon" />;
    case 'MESSAGE PLANS': return <FaCommentAlt className="menu-icon" />;
    case 'PAYMENTS MODES': return <FaCreditCard className="menu-icon" />;
    case 'NETWORK POLICY': return <FaShieldAlt className="menu-icon" />;
    case 'MANAGE DIAGNOSIS': return <FaStethoscope className="menu-icon" />;
    default: return <FaThLarge className="menu-icon" />;
  }
};

const Sidebar = ({ isOpen, onClose, activeTab, selectedItem, onItemClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sidebarMenus = {
    OUTPATIENT: [
      'DASHBOARD',
      'APPOINTMENTS',
      'PATIENTS',
      {
        name: 'REPORT',
        subItems: ['PAYMENTS', 'COLLECTION', 'APPOINTMENT', 'OP CHARGES'],
      }
    ],
    INPATIENT: [
      'DASHBOARD',
      'ADMISSIONS',
      'PATIENTS',
      {
        name: 'MANAGE',
        subItems: ['ROOMS', 'SERVICES'],
      },
      'MONITOR',
      'REPORT',
      'IP TOUR'
    ],
    PHARMACY: [
      'DASHBOARD',
      'PRESCRIPTIONS',
      'ITEMS',
      'PURCHASE ENTRIES',
      'STOCK',
      'SUPPLIERS',
      'PATIENTS',
      'REPORTS',
      'PHARMACY TOUR',
    ],
    'CENTRAL BILLING': ['DASHBOARD', 'CASH COUNTER', 'REPORTS', 'ADMITTED PATIENTS'],
    ADMINISTRATION: [
      'DASHBOARD',
      'HOSPITAL',
      'PHARMACY',
      'LAB',
      'OP/IP PACKAGES',
      'USERS',
      'REPORTS',
      'HOSPITAL CHARGES',
      'DOCTOR PAYMENTS',
      'PATIENTS',
      'ALL ATTACHMENTS',
      'MESSAGE PLANS',
      'PAYMENTS MODES',
      'NETWORK POLICY',
      'MANAGE DIAGNOSIS',
    ],
  };

  const currentMenu = sidebarMenus[activeTab] || [];

  const handleMenuClick = (item) => {
    if (typeof item === 'object' && item.subItems) {
      setExpandedMenu((prev) => (prev === item.name ? null : item.name));
    } else {
      onItemClick(item.name || item);
    }
  };

  return (
    <>
      {isOpen && isMobile && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-top">
          <img src="/VThospitalsLogo.png" alt="Logo" className="sidebar-top-logo" />
          <button className="sidebar-close" onClick={onClose} title="Close Sidebar">
            <FaTimes size={16} />
          </button>
        </div>

        <div className="sidebar-section-title">
          {activeTab} MENU
        </div>

        <nav className="sidebar-menu">
          <ul>
            {currentMenu.map((menuItem, index) => {
              const name = menuItem.name || menuItem;
              const isActive = name === selectedItem;
              const hasSubItems = typeof menuItem === 'object' && menuItem.subItems;

              return (
                <React.Fragment key={index}>
                  <li
                    className={`menu-item-row ${isActive ? 'active-menu' : ''}`}
                    onClick={() => handleMenuClick(menuItem)}
                  >
                    <div className="menu-item-label">
                      {getMenuIcon(name)}
                      <span>{name}</span>
                    </div>

                    {hasSubItems && (
                      <span className="arrow-icon">
                        {expandedMenu === name ? <FaChevronUp size={11} /> : <FaChevronDown size={11} />}
                      </span>
                    )}
                  </li>

                  {/* Submenu */}
                  {hasSubItems && expandedMenu === name && (
                    <ul className="submenu">
                      {menuItem.subItems.map((sub, subIndex) => (
                        <li
                          key={subIndex}
                          className="submenu-item"
                          onClick={() => {
                            onItemClick(sub);
                            setExpandedMenu(null);
                            onItemClick(name);
                            const base = activeTab?.toLowerCase().replace(/\s+/g, '-');
                            const parentPath = name.toLowerCase().replace(/\s+/g, '-');
                            const subPath = sub.toLowerCase().replace(/\s+/g, '-');
                            navigate(`/${base}/${parentPath}/${subPath}`);
                          }}
                        >
                          <span className="sub-bullet">•</span>
                          {sub}
                        </li>
                      ))}
                    </ul>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
